import { css } from 'linaria';
export const sectionStyles = "s1eoaecr";

require("./tool-styles.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./tool-styles.js");